import React from "react";
import "./midia.css";

import CarouselSlider from "../../components/carourselSlider/carourselSlider";

import image1 from "../../assets/img/midia/m_image1.png";
import image2 from "../../assets/img/midia/m_image2.png";
import image3 from "../../assets/img/midia/m_image3.png";
import star from "../../assets/img/midia/m_star.png";

import polygon from "../../assets/img/midia/Polygon.png";

interface Image {
  src: string;
  alt: string;
  type: "image" | "video";
}

const imageList: Image[] = [
//   { src: image1, alt: "Image 1", type: "image" },
//   { src: image2, alt: "Image 2", type: "image" },
//   { src: image3, alt: "Image 3", type: "image" },

  {
    src: "https://www.youtube.com/embed/3114-DC5Yqc",
    alt: "Vídeo 1",
    type: "video",
  },
  {
    src: "https://www.youtube.com/embed/UULKxYLWjDQ?start=23",
    alt: "Vídeo 2",
    type: "video",
  },
  {
    src: "https://www.youtube.com/embed/FrbC3HkUZiQ",
    alt: "Vídeo 3",
    type: "video",
  },
  {
    src: "https://www.youtube.com/embed/U3OFP3AzQcc?start=323",
    alt: "Vídeo 4",
    type: "video",
  },
];

const Midia: React.FC = () => {
  return (
    <div className="midia">
      <div className="header-midia-container">
        <div className="header-midia-content">
          <img src={star} alt="Imagem de estrela" />
          <p>Ripafactory na mídia</p>
          <img src={star} alt="Imagem de estrela" />
        </div>
      </div>

      <div className="midia-midle-container">
        <CarouselSlider images={imageList} />
      </div>

      <div className="midia-end-container">
        <img src={polygon} alt="figura" className="" width={"100%"} />
      </div>
    </div>
  );
};

export default Midia;
